import React, { useRef, useState ,useMemo,useEffect} from "react";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import LoginLeft from "views/newAuth/LoginLeft";
import ReactNotificationAlert from "react-notification-alert";
import PurchaserAuth from "lib/Core/Backend/Controllers/PurchaserAuth";
import { useLocation,useHistory } from "react-router-dom";
import InputGroup from 'react-bootstrap/InputGroup';
import "../../../src/custom.css";
import Notify from "lib/Utils/Alert";

const PurchaserQRLogin = (token) => {
    const location = useLocation();
    
    const [qrData,setQrData] = useState({})
    const [purchaserSession,setPurchaserSession] = useState()

    const history = useHistory()
    const notifyRef = useRef();
    const [mfaCode,setMfaCode] = useState()
    const [showSecret,setShowSecret] = useState(false)
    const purchaserAuthCtl = useMemo(() => new PurchaserAuth(token), [token]);
  
  
  
  
    useEffect(() => {
        try {
            const storedData = localStorage.getItem("QRdata");
            if (storedData) {
                setQrData(JSON.parse(storedData));
            }
        } catch (error) {
            console.error("Error parsing QR data:", error);
            setQrData({}); 
        }
    }, []);

    useEffect(() => {
        try {
            const sessionData = localStorage.getItem("purchaserSession");
            if (sessionData) {
                setPurchaserSession(JSON.parse(sessionData));
            }
        } catch (error) {
            console.error("Error parsing session data:", error);
            setPurchaserSession(null); 
        }
    }, []);

    const handleVerifyTotp = () =>{
        if(qrData?.qrCode){
            let body ={
                totp:mfaCode,
                requestType:"ENABLE_REQUEST",
                username:qrData?.username,
                accessToken:qrData?.accessToken,
                session:qrData?.session
            }
            purchaserAuthCtl.enableTOTP(body,(data)=>{
                if(data && !data.error){
                    setQrData((prev) => {
                        const { qrCode, qrCodeText, ...rest } = prev; 
                        return rest;
                    });
                    Notify(notifyRef,"success","TOTP Authetication is successfullly done")
                }else{
                    Notify(notifyRef,"danger",data?.errormessage ?? data?.error)
                }
            })
        }else{
            let body ={
                totp:mfaCode,
                requestType:"VERIFY_REQUEST",
                username:qrData?.username,
                session:purchaserSession,
            }
            purchaserAuthCtl.enableTOTP(body,(data)=>{
                if(data && !data.error){
                    localStorage.removeItem("QRdata")
                    Notify(notifyRef,"success","Login Successfully")
                    sessionStorage.setItem("accessToken", JSON.stringify(data?.accessToken));
                    history.replace("/purchaser/dashboard");
                }else{
                    Notify(notifyRef,"danger",data?.errormessage ?? data?.error)
                }
            })
        }
    }
    return (
        <div className='authPage'>
            <ReactNotificationAlert ref={notifyRef} />
            <div className="wrap">
                <div className="row g-0">
                    <div className="col-lg-5">
                        <LoginLeft hideCursor={false} />
                    </div>
                    {qrData?.qrCode ? 
                    
                    <div className="col-lg-7 m-0 m-auto">
                        <Container className="py-4">
                            <Row className="mb-4">
                                <Col>
                                    <h1 className="">Set up your authenticator app</h1>
                                    <p className="text-muted">
                                        A virtual MFA device is an application running on your device that
                                        you can configure by scanning a QR Code.
                                    </p>
                                </Col>
                            </Row>

                            
                            <Row className="mb-4">
                                <Col xs={2} sm={1} className="d-flex align-items-center justify-content-center">
                                    <div className="circle fw-bold">1</div>
                                </Col>
                                <Col xs={10} sm={11}>
                                    <p className="mb-0">
                                        Install a compatible application such as Google Authenticator, Duo
                                        Mobile, or Authy app on your mobile device or computer.
                                    </p>
                                </Col>
                            </Row>

                     
                            <Row className="">
                                <Col xs={2} sm={1} className="d-flex align-items-center justify-content-center">
                                    <div className="circle fw-bold">2</div>
                                </Col>
                                <Col xs={10} sm={11} className="">
                                    <Row>
                                        <Col xs={6} sm={4} md={4} xl={3} xxl={2} className="mb-3">
                                            <Card className="d-flex align-items-center justify-content-center" style={{ backgroundColor: "#E0F0FF", minWidth: "145px", maxWidth: "155px", minHeight: "140px", cursor: "pointer" }}>
                                                <Card.Body className="d-flex align-items-center justify-content-center" style={{padding:"0px"}}>
                                                    <div className="border d-flex align-items-center justify-content-center" >
                                                    <img src={`data:image/jpeg;base64,${qrData?.qrCode}`} style={{width:"100%,",height:"100%"}} />
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col xs={6} sm={8} md={7} xxl={9} className="d-flex align-items-center flex-row">
                                            <p>
                                                Open your authenticator app, choose Show QR code on this page,
                                                then use the app to scan the code. Alternatively, you can type a
                                                secret key.{" "}
                                                <a style={{ color: "#2665F2", fontWeight: "bold", cursor: "pointer" }} onClick={()=>setShowSecret(!showSecret)}>
                                                 {showSecret ? "Hide secret key" :"Show secret key"}   
                                                </a>
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6} sm={8} md={7} xxl={9} className >
                                {
                                    showSecret ? 
                                    <p style={{fontWeight:"500"}}> Secret Key: {qrData?.qrCodeText}</p>
                                    :""
                                }
                                </Col>
                                
                            </Row>
                       
                            <Row className="mb-4">
                                <Col xs={2} sm={1} className="d-flex align-items-center justify-content-center">
                                    <div className="circle fw-bold mt-4">3</div>
                                </Col>
                                <Col xs={10} sm={11} className="mt-4">
                                    <Form>
                                        <Form.Group controlId="mfaCode">
                                            <Form.Label>Enter your 6 digit code:</Form.Label>
                                            <p className="m-0">MFA Code 1</p>
                                            <Form.Control type="text" placeholder="Enter MFA Code" className="w-50" value={mfaCode} onChange={(e)=>setMfaCode(e.target.value)} />
                                        </Form.Group>
                                        <button className="mt-3 btn btn-primaryTwo" type="button" onClick={handleVerifyTotp}>
                                            Submit
                                        </button>
                                    </Form>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    :
                    <div className="col-lg-6">
                    <div className="authRight h-100 p-4 p-lg-5">
                      <div className="authRightContent">
                      <h3>Enter OTP Code </h3>
                      <h6 className='mb-4 fs-6 fw-semi'>Your code has been sent to your Authentication App</h6>
                            
                        
                        <div className="formField ">
                          <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon1"><i className='bx bxs-lock-open'></i></InputGroup.Text>
                            <Form.Control
                              placeholder="Enter your OTP for verification"
                              aria-label="OTP"
                              aria-describedby="basic-addon1"
                              type='number'
                              value={mfaCode}
                              onChange={(e) => setMfaCode(e.target.value)}
                            //   className={otpError && 'border-danger'}
                              
                            />
                          </InputGroup>
                        </div>
                        {/* {otpError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{otpError}</p>} */}
                        <div className="text-end mb-4">
                        
                        </div>
                        {/* {verifyLoader ? 
                         <button className='btn btn-primaryTwo w-100'  disabled >
                           Verifying...
                          <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                             
                          </button>
                          : */}
                          <button className='btn btn-primaryTwo w-100' onClick={handleVerifyTotp} >Verify</button>
                      {/* } */}
                        
                      </div>
                    </div>
                  </div>
                            }
                </div>
            </div>
        </div>
    );
};

export default PurchaserQRLogin;
